import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/css/branding.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Lottie from "lottie-web/build/player/lottie_light";
import emptyCartAnimationData from './assets/lotties/loading.json';

ReactDOM.render((
  <Suspense fallback={
    <div id='home-container'>
      {/* <p>Loading…</p> */}
      <div id="animationLoading"/>
      {
        Lottie.loadAnimation({
          container: document.querySelector("#animationLoading"),
          animationData: emptyCartAnimationData,
          loop: false,
          autoplay: true
        }) && <></>
      }
    </div>
  }>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>
  ), document.getElementById('root')
);